import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { MenuCategory, MenuCategoryCreate, MenuCategoryFilter } from '../data/menuCategory';

export function createMenuCategoryService(client: AxiosInstance) {
  return createCrudService<MenuCategory, MenuCategoryCreate, MenuCategoryFilter>(
    client,
    '/restaurant/MenuCategory',
    'menuCategoryId',
  );
}

export type MenuCategoryService = CrudService<MenuCategory, MenuCategoryCreate, MenuCategoryFilter>;
